// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import LinkBack, { LinkBackPresentationProps, LinkBackProps } from "@store/Library/Components/Toolkit/LinkBack";
import { ImgProps } from "@store/MobiusOverrides/Img/Img";
import { LinkProps } from "@store/MobiusOverrides/Link/Link";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, PropsWithChildren, ReactNode } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import BackButton from "@store/Library/Components/BackButton";
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
/* Store Custom Code - End */

const zoneName = "Message";

const wrapperStyles = () => css`
    ${x => spacingStyles(x.theme.design.typography.spacing.large, x.theme.design.typography.spacing.small)}

    && + .message {
        margin-top: 0;
    }
`;

export interface OrderHeaderProps extends ExpandStyles<OrderHeaderStyles> {
    contentId?: string;
    title: string;
    subTitle?: string; // Store Custom Code
    message?: string | ReactNode;
    linkBack?: LinkBackProps["pageLink"];
    linkBackOnClick?: LinkBackProps["onClick"];
    image?: Pick<ImgProps, "src" | "altText">;
    link?: Pick<LinkProps, "href" | "onClick" | "target">;
}

export interface OrderHeaderStyles {
    wrapper?: InjectableCss;
    heading?: HeadingPresentationProps;
    messageWrapper?: InjectableCss;
    zoneWrapper?: InjectableCss;
    linkBack?: LinkBackPresentationProps;
    subHeading?: HeadingPresentationProps; // Store Custom Code
    headingWrapper?: FlexWrapperPresentationProps; // Store Custom Code
}

export const orderHeaderStyles: OrderHeaderStyles = {
    wrapper: {
        css: css`
            margin-bottom: ${pxToRem(40)}; /* Store Custom Code */

            &:last-child {
                margin-bottom: 0;
            }
        `,
    },
    heading: {
        variant: "h4", // Store Custom Code
        forwardAs: "h1", // Store Custom Code
        extendedStyles: {
            title: {
                css: css`
                    margin: 0;
                    /* Store Removed - border-bottom */
                    /* Store Removed - padding */
                `,
            },
        },
    },
    messageWrapper: {
        css: wrapperStyles(),
    },
    zoneWrapper: {
        css: wrapperStyles(),
    },
    // Store Custom Code
    subHeading: {
        variant: "h2",
        extendedStyles: {
            title: {
                css: css`
                    margin: 0;
                `,
            },
        },
    },
    headingWrapper: {
        extendedStyles: {
            content: {
                css: css`
                    justify-content: space-between;
                `,
            },
            item: {
                css: css`
                    align-items: flex-end;
                `,
            },
        },
    },
};

const OrderHeader: FC<PropsWithChildren<OrderHeaderProps>> = ({
    children,
    extendedStyles,
    overridedStyles,
    title,
    contentId,
    message,
    linkBack,
    linkBackOnClick,
    image,
    link,
    subTitle, // Store Custom Code
}) => {
    const styles = useExpandProps(orderHeaderStyles, extendedStyles, overridedStyles);
    const zoneIsActive = useZoneIsActive(contentId || "", zoneName);

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* Store Removed - LinkBack */}
            {/* Store Custom Code - Start */}
            <FlexWrapper {...styles.headingWrapper}>
                <StyledWrapper>
                    <Heading title={title} image={image} link={link} {...styles.heading}></Heading>
                    {subTitle ? <Heading title={subTitle} {...styles.subHeading} /> : null}
                    <BackButton pageLink={linkBack} onClick={linkBackOnClick} />
                </StyledWrapper>
                <StyledWrapper>{children}</StyledWrapper>
            </FlexWrapper>
            {/* Store Custom Code - End */}
            {message ? (
                <StyledWrapper {...styles.messageWrapper} className="message">
                    {message}
                </StyledWrapper>
            ) : null}
            {contentId && zoneIsActive ? (
                <StyledWrapper {...styles.zoneWrapper} className="message">
                    <Zone contentId={contentId} zoneName={zoneName} />
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
};

export default OrderHeader;
